const getBaseURLNoSlash = () => {
  const path = process.env.REACT_APP_FISHERMAN_API_PATH;
  return path.replace(/\/$/, '');
};

export { getBaseURLNoSlash };
